import styled from "styled-components";
import {DatePicker} from "antd";

export const StyledPageHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`;
export const StyledUpcomingCallsWrapper = styled.div`
  padding: 3.2rem 0;
`;
export const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
  margin-bottom: 3rem;
  @media only screen and (max-width: 960px) {
    flex-direction: column;
  }
`;
export const StyledNoUpcomingCallBox = styled.div`
  padding: 3rem 2rem;
  background: #ebebeb;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  .info-text {
    font-weight: 400;
    font-size: 1.4rem;
    text-align: center;
    color: #1c1726;
    max-width: 37.4rem;
  }
`;
export const StyledDescriptionText = styled.p`
  text-overflow: ellipsis;
  width: 15rem;
  white-space: nowrap;
  overflow: hidden;
`;
export const StyledTransactionTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.3rem;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  padding-top: 1rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledTransactionsTableWrapper = styled.div`
  .ant-pagination-item {
    border: 0;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    font-size: 12px;
  }
`;
